import type {
	EventType,
	SchedulersGetSchedulerProfile200,
} from '@cocoonspace/api'
import { cn } from '@cocoonspace/ui/lib/utils'

import { AvatarPreview } from '~/domains/public-page/general-profile-info-form/image-picker/avatar-preview'
import { ProfileBanner } from '~/domains/public-page/profile-banner'
import { formatPersonName } from '~/utils/format-person-name'

export const AnswerProfileHeader = ({
	eventType,
	profile,
}: {
	eventType: EventType
	profile?: SchedulersGetSchedulerProfile200
}) => {
	const ownerName = formatPersonName(
		eventType.user?.firstName,
		eventType.user?.lastName,
	)
	const title = profile?.title || ownerName

	return (
		<header className='relative'>
			<ProfileBanner
				bannerUrl={profile?.styles?.bannerImageUrl}
				logoUrl={profile?.styles?.logoUrl}
			/>
			<div className='relative flex items-center gap-3 px-6 pt-3 pb-4 md:absolute md:bottom-0 md:left-0 md:w-full md:gap-4 md:px-8 md:pt-0 md:pb-5'>
				<AvatarPreview
					avatarUrl={profile?.avatarUrl ?? undefined}
					className='-mt-10 !size-20 shrink-0 ring-4 ring-white md:mt-0 md:!size-24'
				/>
				<div
					className={cn(
						'min-w-0',
						profile?.styles?.bannerImageUrl &&
							'md:bg-card/85 md:rounded-lg md:px-3 md:py-2 md:backdrop-blur-sm',
					)}
				>
					<p className='truncate text-lg font-bold md:text-2xl'>{title}</p>
					{profile?.subtitle && (
						<p className='text-muted-foreground truncate text-sm'>
							{profile.subtitle}
						</p>
					)}
				</div>
			</div>
		</header>
	)
}
